import * as React from 'react';

import classNames from 'classnames';

import Link from '@components/Link';
import { MemberResultProps } from '@presenters/web/pages/Clubs/Members/utils';

import { useTranslation } from '@external/react-i18next';

const ResultsListDesktop: React.FC<MemberResultProps> = ({
  id,
  name,
  email,
  phone,
  role,
  type,
  date,
  status,
}) => {
  const { t } = useTranslation();
  return (
    <div
      data-label="RosterResult"
      className="hidden desktop:flex items-start flex-1 pl-6"
    >
      <div className="w-full member-row-info">
        <div className="flex flex-row w-full items-center h-full">
          <div className="w-20 mr-auto self-center flex-auto mt-5">
            <h3
              className={classNames(
                'text-gray-600 font-bold text-md mb-0 desktop:relative desktop:-mt-4',
                {
                  underline: true,
                }
              )}
            >
              <Link
                noLinkStyles
                to={`/${type}/${id}/manage-membership/candidate-details`}
              >
                {name}
              </Link>
            </h3>
            <div className="flex flex-col leading-6 desktop:w-full tablet:w-auto mr-4">
              {email ? (
                <span className="text-xs mb-0 truncate">
                  <a href={`mailto:${email}`}>{email}</a>
                </span>
              ) : (
                <span className="text-xs mb-0" />
              )}
              <div>
                {phone ? (
                  <span className="text-xs mb-0 text-gray-600 truncate">
                    <span>{phone}</span>
                  </span>
                ) : (
                  <span className="text-xs mb-0" />
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col self-center flex-1 text-xs leading-6 w-16 mr-4">
            <span className="text-xs mb-0 font-normal text-sm text-gray-600">
              {role}
            </span>
            <span className="text-xs mb-0 font-normal text-sm text-gray-600">
              {t('mml.member.submitted-date', 'Submitted')} {date}
            </span>
          </div>
          <div className="flex flex-col self-center flex-1 text-xs leading-6 w-16 mr-4">
            <span className="text-xs mb-0 font-normal text-sm text-gray-600">
              {status}
            </span>
          </div>
          <Link
            to={`/${type}/${id}/manage-membership/candidate-details`}
            className="text-xs mb-0"
          >
            {t('mml.member.view.candidate-details', 'View candidate details')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResultsListDesktop;
